<template>
  <v-dialog v-model="show" width="40vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        <v-row no-gutters>
          <v-col cols="12">
            <span> Producto OP / {{ currentProduct.serial }} </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-autocomplete
                dense
                outlined
                label="Buscar lote"
                prepend-inner-icon="mdi-magnify"
                v-model="folio"
                item-text="loteId"
                return-object
                :search-input.sync="search"
                no-data-text="No se encontro lote"
                :items="folios"
                clearable
                :disabled="
                  isLoadingAssignation ||
                  currentProduct.qtyAssorted == currentProduct.qty
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="py-0" v-if="multiStockIsAvailable">
              <v-autocomplete
                dense
                outlined
                label="Stock"
                v-if="folio"
                :items="stockFromLote"
                item-text="text"
                v-model="stockType"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="font-weight-bold py-0">
              <span
                v-if="folio && stockType == 'STOCK'"
                :class="supplyQty > stock.value ? 'red--text' : ''"
                >Stock:
                {{ supplyQty > 0 ? getDiference() : stock.value }}
                {{ stock.label }}</span
              >
              <span     v-if="folio && stockType == 'STOCK_PT'">
                Stock PT:
                {{
                  stockPTSelected.length > 0
                    ? stockPT.length - stockPTSelected.length
                    : stockPT.length
                }}
                pz</span
              >
              <v-spacer></v-spacer>
              <span>Piezas necesarias: {{ currentProduct.qty }} pz</span>
              <v-spacer></v-spacer>
              <span>Piezas apartadas: {{ currentProduct.qtyAssorted }} pz</span>
            </v-col>
            <v-col cols="10" v-if="stockType == 'STOCK'">
              <v-form ref="formQty" lazy-validation>
                <v-text-field
                  label="Número de piezas a surtir"
                  dense
                  outlined
                  type="number"
                  v-model="supplyQty"
                  :error="validation.error"
                  :error-messages="validation['error-messages']"
                  :rules="validationNumber()"
                  :disabled="isLoadingAssignation"
                ></v-text-field>
              </v-form>
            </v-col>
            <v-col cols="10" v-if="stockType == 'STOCK_PT'">
              <v-form ref="formQtyPT" lazy-validation>
                <v-autocomplete
                  multiple
                  chips
                  label="Selecciona PT"
                  :item-text="formatItemText"
                  dense
                  outlined
                  :items="stockPT"
                  v-model="stockPTSelected"
                  clearable
                  :error="validation.error"
                  :error-messages="validation['error-messages']"
                  :disabled="isLoadingAssignation"
                  return-object
                ></v-autocomplete>
              </v-form>
            </v-col>
            <v-col
              cols="2"
              align="center"
              justify="center"
              v-if="stockType == 'STOCK'"
            >
              <v-btn
                color="primary"
                block
                rounded
                @click="assignDoses"
                :loading="isLoadingAssignation"
              >
                <v-icon> mdi-wall-sconce-round-variant </v-icon>
              </v-btn>
            </v-col>
            <v-col
              cols="2"
              align="center"
              justify="center"
              v-if="stockType == 'STOCK_PT'"
            >
              <v-btn
                color="primary"
                block
                rounded
                @click="assignPT"
                :loading="isLoadingAssignation"
              >
                <v-icon> mdi-wall-sconce-round-variant </v-icon>
              </v-btn>
            </v-col>
            <v-col class="py-0">
              <div v-for="(item, index) in lotesAssigned" :key="index">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      close
                      @click:close="removeDoses(index)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.loteId }}
                    </v-chip>
                  </template>
                  <span> Dosis: {{ item.doses }}</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="gray"
                block
                @click="closeModal"
                dark
                :disabled="isLoadingAssignation"
                >Cerrar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
//validations
import { numberValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    folio: null,
    search: null,
    loader: false,
    loteSelected: null,
    lotesAssigned: [],
    stock: 0,
    stockFromLote: [],
    stockType: null,
    folios: [],
    multiStockIsAvailable: false,
    supplyQty: null,
    validation: {
      error: false,
      "error-messages": "",
    },
    stockPTSelected: [],
    stockPT: [],
    isLoadingAssignation: false,
    currentProduct: null,
  }),
  props: {
    value: Boolean,
    title: String,
  },
  computed: {
    ...mapState("lotes", ["productSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("order", [
      "getFolioStock",
      "setLoteInProduct",
      "removeStockFromProduct",
    ]),
    ...mapMutations("order", ["SET_PRODUCT_SELECTED"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    formatItemText(item) {
      return `${item.loteId} / 1 pz / ${item.presentation.value} ${item.presentation.units}/ - ${item.id}`;
    },
    getDiference() {
      if (
        this.currentProduct &&
        this.currentProduct.presentation.units == "ml"
      ) {
        return (
          this.stock.value -
          (this.supplyQty * parseInt(this.currentProduct.presentation.value)) /
            1000
        );
      } else {
        if (this.currentProduct.presentation.value == "1000") {
          // 2 doses
          return this.stock.value - this.supplyQty * 2;
        } else {
          // 1 dose
          return this.stock.value - this.supplyQty;
        }
      }
    },
    validationNumber() {
      return numberValidation({ min: 1, required: true });
    },
    closeModal() {
      this.show = false;
    },

    confirmation() {
      //emit desision
      this.$emit("confirmation");
      this.closeModal();
    },
    async assignDoses() {
      if (this.$refs.formQty.validate()) {
        let flag = true;

        if (this.supplyQty > this.stock.value) {
          this.validation.error = true;
          this.validation["error-messages"] = "Stock insuficiente";
          flag = false;
        } else if (this.supplyQty > this.currentProduct.qty) {
          this.validation.error = true;
          this.validation["error-messages"] = "Exceso de dosis en asignación";
          flag = false;
        }

        if (flag) {
          // assign stock
          this.validation.error = false;
          this.validation["error-messages"] = "";
          this.isLoadingAssignation = true;
          try {
            let paylaod = {
              doses: this.supplyQty,
              lote: this.folio._id,
              productId: this.currentProduct._id,
              type: this.stockType,
              assignedPieces: this.stockPTSelected,
            };
            let response = await this.setLoteInProduct(paylaod);
            if (!response) throw response;
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Dosis apartadas",
              timeout: 3500,
            });
            this.$emit("fetchData");
            this.folio = null;
            this.supplyQty = null;
            this.currentProduct = response.product;
            if (this.currentProduct.qtyAssorted == this.currentProduct.qty) {
              console.log("HERE");
              this.stockType = null;
            }
            console.log(response.product);
            this.SET_PRODUCT_SELECTED(response.product);
            this.setCurrentStockProdduct();
          } catch (error) {
            console.log(error);
            this.$swal({
              icon: "error",
              title: `Algo salio mal al asignar lote, intente de nuevo`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
          this.isLoadingAssignation = false;
        }
      }
    },
    async assignPT() {
      let flag = true;

      if (this.stockPTSelected.length <= 0) {
        this.validation.error = true;
        this.validation["error-messages"] = "Seleccióna stock";
        flag = false;
      } else if (this.stockPTSelected > this.currentProduct.qty) {
        this.validation.error = true;
        this.validation["error-messages"] = "Exceso de dosis en asignación";
        flag = false;
      }

      if (flag) {
        // assign stock
        this.validation.error = false;
        this.validation["error-messages"] = "";
        this.isLoadingAssignation = true;
        try {
          let paylaod = {
            doses: this.supplyQty,
            lote: this.folio._id,
            productId: this.currentProduct._id,
            type: this.stockType,
            assignedPieces: this.stockPTSelected,
          };
          console.log(paylaod);
          let response = await this.setLoteInProduct(paylaod);
          if (!response) throw response;
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Dosis apartadas",
            timeout: 3500,
          });
          this.$emit("fetchData");
          this.folio = null;
          this.supplyQty = null;
          this.currentProduct = response.product;
          this.stockPTSelected = []
            this.stockType = null;
          // if (this.currentProduct.qtyAssorted == this.currentProduct.qty) {
          //   this.stockType = null;
          // }
          console.log(response.product);
          this.SET_PRODUCT_SELECTED(response.product);
          this.setCurrentStockProdduct();
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al asignar lote, intente de nuevo`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoadingAssignation = false;
      }
    },
    setCurrentStockProdduct() {
      this.lotesAssigned = this.currentProduct.lotes;
    },
    async removeDoses(index) {
      try {
        let payload = {
          productId: this.currentProduct._id,
          assignedLote: this.lotesAssigned[index],
        };
        let response = await this.removeStockFromProduct(payload);
        if (!response) throw response;
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Dosis removidas",
          timeout: 3500,
        });
        this.$emit("fetchData");
        this.supplyQty = null;
        this.stockType = null;
        this.currentProduct = response.productUpdated;
        this.SET_PRODUCT_SELECTED(response.productUpdated);
        this.setCurrentStockProdduct();
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al remover dosis, intente de nuevo`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
  created() {
    this.currentProduct = this.productSelected;
    this.setCurrentStockProdduct();
  },
  watch: {
    async search(value) {
      try {
        if (!value) return;
        let payload = {
          folio: value,
          identification: this.currentProduct.identification
            ? this.currentProduct.identification.identification
            : null,
        };
        let response = await this.getFolioStock(payload);
        if (!response) throw response;
        this.folios = response.lotes;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al buscar folio",
          timeout: 3500,
        });
      }
    },
    folio(value) {
      if (!value) return;
      if (value.stockPT && value.stockPT.length > 0) {
        this.multiStockIsAvailable = true;
        this.stockFromLote = [
          { text: "Stock espora", value: "STOCK" },
          { text: "Stock PT", value: "STOCK_PT" },
        ];
        this.stockPT = value.stockPT;
      }
      this.stockType = "STOCK";
    },
    stockType(value) {
      this.stockPTSelected = []
      if (!value) return;
      if (value == "STOCK") {
        if (
          this.currentProduct.identification &&
          (this.currentProduct.identification.moType == "fungi" ||
            this.currentProduct.identification.identificationName ==
              "Streptomyces griseoviridis")
        ) {
          // fungo
          this.stock = {
            label: `dosis (Espora)`,
            value: this.folio.possibleDosage,
          };
        } else {
          // bacteria and fortizol
          this.stock = {
            label: `dosis (Litros)`,
            value: this.folio.stock,
          };
        }
      }
      //  else {
      //   // fungi stock finished product
      //   this.stock = this.folio.stockPT ? this.folio.stockPT : [];
      // }
    },
  },
};
</script>
